import { showModal } from '../actions/ModalActions';

/** Modal key registered in `src/modals/index.js`. */
export const CREATE_SUPPORT_TICKET_MODAL_TYPE = 'CreateSupportTicket';

/** Redux action that opens the Create Support Ticket modal (same payload as Support widget). */
export function getCreateSupportTicketModalAction() {
  return showModal(
    {
      isOpen: true,
      position: 'center',
    },
    CREATE_SUPPORT_TICKET_MODAL_TYPE
  );
}
